export const initialValues = {
  title: '',
  description: '',
  preview: '',
  difficulty: 'EASY',
  format: '',
  free: false,
};
